module.exports = __webpack_public_path__ + "img/img-about.dcfa8e53.png";